import apiClient from "../utils/apiClient";

export const createContact = (contact: Contact) =>
  apiClient.post("/contacts", contact).then(({ data }) => data);
